import { render, staticRenderFns } from "./fileDataMars.vue?vue&type=template&id=638a2052&scoped=true&"
import script from "./fileDataMars.vue?vue&type=script&lang=js&"
export * from "./fileDataMars.vue?vue&type=script&lang=js&"
import style0 from "./fileDataMars.vue?vue&type=style&index=0&id=638a2052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a2052",
  null
  
)

export default component.exports